<template>
  <v-dialog v-model="isOpen" max-width="500px" persistent  content-class="bra-20">
    <v-card>
      <v-card-title class="headline text-danger">
        Confirmação
        <v-spacer />
        <v-btn icon @click="fechar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <slot>
          Tem certeza de que deseja excluir este item? Essa ação não poderá ser desfeita.
        </slot>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" small dark @click="confirmar">sim, confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api/api";

export default {
  name: 'SysDialogDelete',
  props: {
    item: Array,
    url_delete: { type: String, required: true }
  },
  emits: ['update:modelValue', 'deleted', 'error'],
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    item(val) {
      this.isOpen = (val.length > 0);
    }
  },
  methods: {
    fechar() {
      this.isOpen = false;
      this.$emit('reset-item');
    },
    async confirmar() {
      const params = this.item;

      await api.post(this.url_delete, params)
        .then(() => {
          this.isOpen = false;
          this.$emit('deleted');
        })
        .catch((error) => {
          this.$emit('error', error);
        });
    }
  }
}
</script>
